import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import {AdminProvider} from "../../contexts/adminsContext/AdminContext";

const AdminFragment = Loadable(lazy(() => import('./views/AdminFragment')));
const AddAdminFragment = Loadable(lazy(() => import('./views/AddAdminFragment')));

const adminsRoutes = [
    { path: '/admins', element: <AdminProvider><AdminFragment /></AdminProvider> },
    { path: '/add_admin', element: <AdminProvider><AddAdminFragment /></AdminProvider> },
    { path: '/add_admin/:id', element: <AdminProvider><AddAdminFragment /></AdminProvider> }
];

export default adminsRoutes;
